import React from 'react';
import RiskAssessmentFormModal from './components/RiskAssessmentFormModal';

import useRiskAssessmentForm from './hooks/use-risk-assessment-form';
import RiskAssessmentResultModal from '../RiskAssessmentResult/components/RiskAssessmentResultModal';
import useRiskAssessmentStep from './hooks/use-risk-assessment-step';
interface Props {
  renderTrigger: (props: { onClick: () => void }) => React.ReactElement;
}

const PregnancyRiskAssessmentForm = ({ renderTrigger }: Props) => {
  const { form, saveAnswer } = useRiskAssessmentForm();
  const { step, onTriggerClicked, onSubmitClicked, onClose } = useRiskAssessmentStep();

  const hasRisk = form?.fields.some(field => field.answer) ?? false;

  return (
    <>
      {renderTrigger({ onClick: onTriggerClicked })}
      <RiskAssessmentFormModal
        isOpen={step === 'formOpen'}
        form={form}
        onClose={onClose}
        onSaveAnswer={saveAnswer}
        onSubmit={() => onSubmitClicked(form)}
      />
      <RiskAssessmentResultModal
        isOpen={step === 'resultOpen'}
        onClose={onClose}
        hasRisk={hasRisk}
      />
    </>
  );
};

export default PregnancyRiskAssessmentForm;
